<div class="f-loader" [class.bg-black]="isBGBlack" *ngIf="activeLoader | async" [@default]>
    <p class="loader-text">Processing...</p>
    <img [src]="'/assets/images/preloader.gif'" alt="loading" class="loader" />
</div>
  